// src/reducers/salesorder.reducer.js

import { salesGraphsConstants } from "../constants";
import { salesChartsDebug } from "../helpers/salesChartsDebug";

export function salesgraphs(state = {}, action) {
  if (action && action.type) {
    switch (action.type) {
      case salesGraphsConstants.SALES_GRAPHS_REQUEST: {
        const next = { ...state, retrievingGR: true };
        salesChartsDebug("reducer SALES_GRAPHS_REQUEST", {
          hadGraphs: Boolean(state.graphs),
          prevKeys: Object.keys(state),
        });
        return next;
      }
      case salesGraphsConstants.SALES_GRAPHS_SUCCESS: {
        const next = {
          ...state,
          retrievingGR: false,
          searchingGR: false,
          graphs: action.orders,
        };
        salesChartsDebug("reducer SALES_GRAPHS_SUCCESS", {
          graphKeys:
            action.orders && typeof action.orders === "object"
              ? Object.keys(action.orders)
              : typeof action.orders,
        });
        return next;
      }
      case salesGraphsConstants.SALES_GRAPHS_FAILURE: {
        const next = { ...state, retrievingGR: false };
        salesChartsDebug("reducer SALES_GRAPHS_FAILURE", {
          error: action.error,
          stillHasGraphs: Boolean(state.graphs),
        });
        return next;
      }

      case salesGraphsConstants.SALES_GRAPHS_DETAILS_REQUEST: {
        const next = { ...state, retrievingGR: true };
        salesChartsDebug("reducer SALES_GRAPHS_DETAILS_REQUEST", {
          hadGraphs: Boolean(state.graphs),
        });
        return next;
      }
      case salesGraphsConstants.SALES_GRAPHS_DETAILS_SUCCESS: {
        const next = {
          ...state,
          retrievingGR: false,
          searchingGR: false,
          graphs: action.order,
        };
        salesChartsDebug("reducer SALES_GRAPHS_DETAILS_SUCCESS", {
          graphKeys:
            action.order && typeof action.order === "object"
              ? Object.keys(action.order)
              : typeof action.order,
        });
        return next;
      }
      case salesGraphsConstants.SALES_GRAPHS_DETAILS_FAILURE: {
        const next = { ...state, retrievingGR: false };
        salesChartsDebug("reducer SALES_GRAPHS_DETAILS_FAILURE", {
          error: action.error,
        });
        return next;
      }

      case salesGraphsConstants.SALES_GRAPHS_SEARCH_REQUEST: {
        const next = { ...state, searchingGR: true };
        salesChartsDebug("reducer SALES_GRAPHS_SEARCH_REQUEST", {
          hadGraphs: Boolean(state.graphs),
        });
        return next;
      }
      case salesGraphsConstants.SALES_GRAPHS_SEARCH_SUCCESS: {
        const next = {
          ...state,
          retrievingGR: false,
          searchingGR: false,
          graphs: action.orders,
        };
        salesChartsDebug("reducer SALES_GRAPHS_SEARCH_SUCCESS", {
          graphKeys:
            action.orders && typeof action.orders === "object"
              ? Object.keys(action.orders)
              : typeof action.orders,
        });
        return next;
      }
      case salesGraphsConstants.SALES_GRAPHS_SEARCH_FAILURE: {
        const next = { ...state, searchingGR: false };
        salesChartsDebug("reducer SALES_GRAPHS_SEARCH_FAILURE", {
          error: action.error,
        });
        return next;
      }

      default:
        return state;
    }
  }
}
